import { render, staticRenderFns } from "./BotItem.vue?vue&type=template&id=95daeb24&"
import script from "./BotItem.vue?vue&type=script&lang=js&"
export * from "./BotItem.vue?vue&type=script&lang=js&"
import style0 from "./BotItem.vue?vue&type=style&index=0&id=95daeb24&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports